<template>
  <div class="task-list-title">
    <h3>Day {{ day }} 任务列表</h3>
    <!-- 任务列表内容现在由 HomePage 处理 -->
  </div>
</template>

<script>
// 移除未使用的导入
// import { ref, watch, onMounted } from 'vue';
// import TaskCard from './TaskCard.vue'; // 移除 TaskCard 导入
// import taskApi from '../api/task'; 
// import { ElMessage } from 'element-plus'; 

export default {
  // 移除 components
  // components: {
  //   TaskCard,
  // },
  props: {
    day: {
      type: Number,
      required: true,
    },
    tasks: { // 保留 tasks prop 以便判断是否显示列表标题或空状态
        type: Array,
        default: () => [],
    }
    // 移除 user prop，TaskCard 直接从 store 获取
    // user: {
    //     type: Object,
    //     default: null,
    // },
  },
  // 移除 emits
  // emits: ['refreshTasks'], 
  setup() {
    // 移除所有 setup 逻辑
    return {};
  },
};
</script>

<style scoped>
.task-list-title {
  margin-top: 20px;
  margin-bottom: 15px; /* 添加一些底部外边距 */
}
</style> 